// @flow
import { MEDIA_TEXT_VERTICAL } from 'Client/cms/toolkit/constants';
import { MediaTextVerticalLine } from 'Components/lines/media-text-vertical-line/MediaTextVerticalLine.jsx';
import { mediaTextVerticalResolver } from './mediaTextVertical.resolver';

export const mediaTextVerticalDescriptor = {
  name: MEDIA_TEXT_VERTICAL,
  component: MediaTextVerticalLine,
  resolve: mediaTextVerticalResolver.resolve,
};
